import {Columns} from 'compob2b-table';
import {translations} from '../../../../environments/translations.ru';
import {environment} from '../../../../environments/environment';

export const CATALOG_FORM: Columns[] = [
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },

  // {
  //   key: 'catalogTreeSynonym',
  //   title: 'Обновить синонимы во всех дочерних разделах',
  //   placeholder: 'Обновить синонимы во всех дочерних разделах',
  //   searchEnabled: false,
  //   defaultValue: false,
  //   formly: true,
  //   grid: false,
  //   type: 'checkbox',
  //   required: false,
  // },

  {
    key: 'parentId',
    title: translations.parent,
    placeholder: translations.parent,
    searchEnabled: true,
    formly: true,
    type: 'catalog-picker',
    templateOptions: {
      label: translations.parent,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header',
      chooseOnlyLastLevel: false,
    },
    width: '100%'
  },
  {
    key: 'syncUid',
    title: translations.syncUid,
    placeholder: translations.syncUid,
    searchEnabled: false,
    formly: true,
    type: 'input',
    templateOptions: {
      label: translations.syncUid,
      readonly: true
    },
    hideExpression: 'model.editMode === false'
  },
  {
    key: 'htHead',
    title: translations.htHead,
    placeholder: translations.htHead,
    searchEnabled: false,
    formly: true,
    type: 'input',
  },
  {
    key: 'htDesc',
    title: translations.htDesc,
    placeholder: translations.htDesc,
    searchEnabled: false,
    formly: true,
    type: 'input',
  },
  {
    key: 'htKeywords',
    title: translations.htKeywords,
    placeholder: translations.htKeywords,
    searchEnabled: false,
    formly: true,
    type: 'input',
  },
  {
    key: 'content',
    title: translations.content,
    placeholder: translations.content,
    searchEnabled: true,
    formly: true,
    type: 'editor-input',
    width: '100%'
  },
  {
    key: 'channelIDs',
    title: translations.channel,
    placeholder: translations.channel,
    formly: true,
    type: 'multicheckbox',
    grid: true,
    templateOptions: {
      label: translations.channel,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header'
    },
    hideExpression: 'model.level !== 2'
  },
  {
    key: 'pictureInput',
    title: '',
    searchEnabled: false,
    orderEnabled: false,
    picture: true,
    type: 'file-upload-input',
    required: true,
    templateOptions: {
      fileOptions: {
        maxFileSize: 5 * 1024 * 1024, // 5Mb
        allowedMimeType: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif']
      },
    }
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    defaultValue: true,
    type: 'checkbox',
  },
  {
    key: 'pos',
    title: translations.position,
    placeholder: translations.position,
    searchEnabled: false,
    formly: true,
    type: 'input',
    className: 'formly-middle',
    cssClass: {includeHeader: false, name: 'font-small'}
  },
  {
    key: 'roles',
    title: translations.roles,
    placeholder: translations.roles,
    formly: true,
    type: 'multicheckbox',
    grid: false,
    templateOptions: {
      label: translations.roles,
      placeholder: translations.roles,
      required: true,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header',
      description: 'Роли может изменять только супер администратор',
    },
    hideExpression: !environment.accessRolesCatalog,
  }, {
    key: 'action',
    title: translations.htKeywords,
    placeholder: translations.htKeywords,
    searchEnabled: false,
    orderEnabled: false,
    grid: true,
    type: 'input',
    required: true
  }
];
